export default __webpack_public_path__ + "static/sst+flow-c250d7148ead45ae2fad222049d683a1.png";